module.exports = "/images/tool-checkbox-checked.svg?58f91665dc917137824ee8e1e271ee2f";